'use client';

import { useLocale } from 'next-intl';
import { isRightToLeft, getRtlDirection } from '@/utils/rtl';

/**
 * Hook to get RTL information for the current locale
 */
export function useRtl() {
  const locale = useLocale();
  const isRtl = isRightToLeft(locale);
  const direction = getRtlDirection(locale);

  return {
    isRtl,
    direction,
    locale,
    // Convenient CSS classes that use the direction directly
    directionClass: direction,
    textAlign: isRtl ? 'text-right' : 'text-left',
    textAlignStart: 'text-start', // Uses CSS logical properties
    textAlignEnd: 'text-end'      // Uses CSS logical properties
  };
}

/**
 * Hook to get RTL-aware CSS classes
 */
export function useRtlClasses() {
  const { isRtl, direction } = useRtl();

  return {
    container: direction,
    textAlign: isRtl ? 'text-right' : 'text-left',
    marginLeft: isRtl ? 'mr-auto' : 'ml-auto',
    marginRight: isRtl ? 'ml-auto' : 'mr-auto',
    paddingLeft: (size: string) => isRtl ? `pr-${size}` : `pl-${size}`,
    paddingRight: (size: string) => isRtl ? `pl-${size}` : `pr-${size}`,
    borderLeft: isRtl ? 'border-r' : 'border-l',
    borderRight: isRtl ? 'border-l' : 'border-r',
    justifyStart: isRtl ? 'justify-end' : 'justify-start',
    justifyEnd: isRtl ? 'justify-start' : 'justify-end'
  };
}
